<div *ngIf="isOneRow()" class="h-full">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
<!--
@if (isShowTravelBuddy) {
  @defer (on timer(2000)) {
    <ig-ai-buddy-place-listing></ig-ai-buddy-place-listing>
  }
} -->

<mat-sidenav-container *ngIf="!isOneRow() && !isAiAssistant()" id="imgoing-container" class="h-full"
  [class.default-color]="isIE">

  <mat-sidenav #sideBar mode="over" class="w-[80%]">
    <ig-side-bar *ngIf="isMobile" (onClose)="sideBar.close()"></ig-side-bar>
  </mat-sidenav>
  <mat-sidenav-content class="h-full" *ngIf="frontendSettings$ | async as settings">
    <div class="page-header" *ngIf="isMobile && isShowMenuBar()">
      <mat-icon class="text-2xl" role="button" (click)="sideBar.open()">menu</mat-icon>
      <div class="text-2xl my-3">More Options</div>
    </div>
    <div class="h-full">
      <ig-top-bar *ngIf="isTopbar(settings) && isShowMenuBar()"></ig-top-bar>

      <div class="flex relative min-h-[600px]" [ngStyle]="{'height':isTopbar(settings)&&(!isEmbeddingSubmitForm&&!isJobBoard)?'calc(100% - 96px)':'100%'}">
        <div *ngIf="isSidebar(settings) && isShowMenuBar()" class="flex-[3]"
          [class.!w-[56px]]="!isMobile && isSidebarCollapsed"
          [class.!flex-[0]]="!isMobile && isSidebarCollapsed">
          <ig-side-bar (toggleCollapse)="toggleSidebarCollapse()"></ig-side-bar>
          <button *ngIf="!isMobile" mat-icon-button
            class="!absolute -right-3 top-1/2 -translate-y-1/2 z-10 bg-white rounded-full shadow cursor-pointer border border-gray-200"
            (click)="toggleSidebarCollapse()" [attr.aria-expanded]="!isSidebarCollapsed" aria-controls="visitor-sidebar">
            <mat-icon class="text-gray-600">{{isSidebarCollapsed ? 'chevron_right' : 'chevron_left'}}</mat-icon>
          </button>
        </div>
        <div class="flex-[9] mobile:w-full" [class.!flex-[1]]="!isMobile && isSidebarCollapsed">
          <router-outlet #outlet="outlet"></router-outlet>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<!-- NormanOK uses in-app browser, which shows this browser check and cannot hide -->
<div *ngIf="!isMobile">
  <div *ngIf="isIE&&isShowUpgradeBrowser&&hubName!=='NormanOK'" class="browser-upgrade-wrap">
    Your web browser is out of date. Update to a modern browser (Chome or Firefox) for more security, speed and the
    best
    experience on this site.
    <button mat-flat-button class="bg-green-400" (click)="upgradeBrowser()">Upgrade</button>
    <button mat-flat-button class="ml-2 bg-amber-400" (click)="hideUpgradeBrowser()">ignore</button>
  </div>
</div>

<div *ngIf="frontendSettings && frontendSettings.status !== 'live'"
  class="w-full h-full flex flex-col gap-8 justify-center items-center text-xl absolute top-0 left-0 z-10 bg-white">
  <b class="text-2xl">Temporarily Unavailable.</b>
  <span>This section of the site is currently offline.</span> <span>For more
    information, please
    contact {{hubName === 'LivingstonTN' ? 'the Livingston Overton County Chamber of Commerce at (931)
    823-6421.' :
    'the site owner directly.'}}</span>
</div>
